import { useCallback, useEffect, useState } from "react";
import validacaoFiscalService from "../../../services/validacaoFiscalService";

/**
 * Gerencia a competência ativa do módulo de Validação Fiscal.
 *
 * Se o projeto ainda não tiver nenhuma competência aberta, `mode` retorna
 * "mock" e as abas devem seguir usando os dados de exemplo (`mockData.js`),
 * no mesmo padrão do módulo Reforma Tributária (`useReformaFiscalData`).
 */
export default function useValidacaoFiscalData() {
  const [state, setState] = useState({
    mode: "loading", // "loading" | "real" | "mock"
    loading: true,
    error: null,
    competencias: [],
    competenciaId: null,
  });

  const carregar = useCallback(async () => {
    setState((prev) => ({ ...prev, mode: "loading", loading: true, error: null }));
    try {
      const resp = await validacaoFiscalService.listarCompetencias();
      const competencias = resp?.data?.data || [];

      if (competencias.length === 0) {
        setState({ mode: "mock", loading: false, error: null, competencias: [], competenciaId: null });
        return;
      }

      // Competência ativa = a mais recente que não esteja congelada; se todas
      // estiverem congeladas, usa a mais recente mesmo assim (modo leitura).
      const ativa = competencias.find((c) => c.status !== "congelada") || competencias[0];

      setState({ mode: "real", loading: false, error: null, competencias, competenciaId: ativa.id });
    } catch (error) {
      console.error("[useValidacaoFiscalData] Erro ao carregar competências:", error);
      setState({ mode: "mock", loading: false, error: error.message, competencias: [], competenciaId: null });
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const abrirCompetencia = useCallback(
    async (ano, mes, tributo = "cbs") => {
      const resp = await validacaoFiscalService.abrirCompetencia({ ano, mes, tributo });
      await carregar();
      return resp?.data?.data;
    },
    [carregar]
  );

  const selecionarCompetencia = useCallback((id) => {
    setState((prev) => ({ ...prev, competenciaId: id }));
  }, []);

  return { ...state, refresh: carregar, abrirCompetencia, selecionarCompetencia };
}
